 import Vue from 'vue'
 
 var vueEvent = new Vue();
 
 export default vueEvent;


//////////////////
// WEBPACK FOOTER
// ./static/js/vueEvent.js
// module id = null
// module chunks = 